import {
  RESET_CUSTOMER_DASHBOARD_ISFETCHING,
  CUSTOMER_DASHBOARD_OBJECT_REQUESTING,
  GET_CUSTOMER_DASHBOARD_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  isObjectFetching: false,
  total: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CUSTOMER_DASHBOARD_ISFETCHING: {
      return {
        ...state,
        isObjectFetching: false
      };
    }
    case CUSTOMER_DASHBOARD_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }

    case GET_CUSTOMER_DASHBOARD_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
